import React, { useRef, useState } from "react";
import ShopSidebar from "../../wrappers/product/ShopSidebar";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";

export default function MobileFilter({
  isOpen,
  setIsOpen,
  categories = true,
  products,
  getSortParams,
  getFilterSortParams,
  sortType,
  setSortType,
  setSortValue,
  setActiveSort,
  setMax,
  setMin,
  minRef,
  maxRef,
  min,
  max,
  ratingFilter,
  setRatingFilter,
  brandsFilter,
  setSort,
  setBrandsFilter,
  categoriesItems,
  categoriesFilter,
  setCategoriesFilter,
  setSearch,
}) {
  const { t } = useTranslation();
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);

  return (
    <div
      className="d-md-none position-fixed w-100 h-50 bg-white overflow-auto rounded-top-4 pb-3 m-0"
      style={{
        zIndex: 99999999,
        bottom: `${isOpen ? "0" : "-150%"}`,
        left: 0,
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.3)",
        transition: "all 0.5s ease-in-out",
      }}
    >
      <button
        className="position-sticky btn p-0"
        style={{ top: 13, insetInlineStart: "109%", zIndex: 999999 }}
        onClick={() => setIsOpen(false)}
      >
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 1024 1024"
          fill="#000000"
          className="icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth={0} />
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="SVGRepo_iconCarrier">
            <path
              d="M332 663.2c-9.6 9.6-9.6 25.6 0 35.2s25.6 9.6 35.2 0l349.6-356c9.6-9.6 9.6-25.6 0-35.2s-25.6-9.6-35.2 0L332 663.2z"
              fill
            />
            <path
              d="M681.6 698.4c9.6 9.6 25.6 9.6 35.2 0s9.6-25.6 0-35.2L367.2 307.2c-9.6-9.6-25.6-9.6-35.2 0s-9.6 25.6 0 35.2l349.6 356z"
              fill
            />
            <path
              d="M516.8 1014.4c-277.6 0-503.2-225.6-503.2-503.2S239.2 7.2 516.8 7.2s503.2 225.6 503.2 503.2-225.6 504-503.2 504z m0-959.2c-251.2 0-455.2 204.8-455.2 456s204 455.2 455.2 455.2 455.2-204 455.2-455.2-204-456-455.2-456z"
              fill
            />
          </g>
        </svg>
      </button>
      <div className="sidebar-widget mb-3">
        <h4 className="pro-sidebar-title mb-4">{t("filter_by_price")} </h4>
        <div className="d-flex gap-2">
          <input
            ref={minRef}
            type="text"
            placeholder={t("min")}
            onChange={(e) => setMin(e.target.value)}
            className="bg-white border-1"
          />
          <input
            ref={maxRef}
            type="text"
            onChange={(e) => setMax(e.target.value)}
            placeholder={t("max")}
            className="bg-white border-1"
          />
        </div>
      </div>
      <ShopSidebar
        minRef={minRef}
        maxRef={maxRef}
        min={min}
        max={max}
        setMin={setMin}
        setMax={setMax}
        price={false}
        setSearch={setSearch}
        brandsFilter={brandsFilter}
        ratingFilter={ratingFilter}
        setRatingFilter={setRatingFilter}
        setSort={setSort}
        setBrandsFilter={setBrandsFilter}
        categoriesFilter={categoriesFilter}
        setCategoriesFilter={setCategoriesFilter}
        categoriesItems={categoriesItems}
        getFilterSortParams={getFilterSortParams}
        products={products?.products}
        getSortParams={getSortParams}
        sideSpaceClass="ml-30"
        categories={categories}
      />
      {(sortType ||
        categoriesFilter?.length > 0 ||
        brandsFilter?.length > 0 ||
        ratingFilter?.length > 0 ||
        min ||
        max) && (
        <button
          className="btn btn-danger mt-5"
          onClick={() => {
            setSortType("");
            setSortValue("");
            setMin();
            setMax();
            setCategoriesFilter([]);
            setBrandsFilter([]);
            setRatingFilter([]);
            setActiveSort("");
          }}
        >
          {t("clear")}
        </button>
      )}
    </div>
  );
}
